/**!
 * Created by Leonardo Cheslacki on 28/06/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import LayerController from './LayerController';

import {HelpersIcon} from './../helpers';

import config from '../../../../config';

const {default: {button}} = config;

import WithType from './../helpers/WithType';

let _this = {};

/**
 *
 */
class LayerCamera extends LayerController {
    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);
        this.props = props;
        this.main = main;

        this.state = {
            effect: true
        }

        const {current_name} = this.props;

        this.$helpersIcon = HelpersIcon(this)({current_name: current_name});

        this.$children_temp = [];

        _this = this;
    };

    $functions = {

        handleCameraShow: function () {
            const _this_current = _this.get();
            _this.$children_temp = _this_current.children;
            _this.show();
            _this_current.children = _this_current.children.filter((value) => {
                return (value.name === 'occ_camera');
            });
        },

        handleCameraClose: function () {
            const _this_current = _this.get();
            _this.close();
            _this_current.children = _this.$children_temp;
        }
    };

    /**
     *
     * @param frame
     */
    navigate = (frame) => {
        const
            {effect} = this.state,
            _this_current = this.get(),
            {occ_camera} = _this_current;

        if (frame !== 'empty') {
            occ_camera.gotoAndStop(frame);
            this.effectFadeIn(occ_camera, `occ_frame_${this.occurrence()}`);
        } else {
            if (effect) {
                this.effectFadeOut(occ_camera, `occ_frame_${this.occurrence()}`, () => {
                    occ_camera.gotoAndStop(frame);
                });
            } else {
                occ_camera.gotoAndStop(frame);
            }
        }

        this.setState({...this.state, effect: true});
    };

    close = () => {
        this.navigate('empty');
    };

    show = () => {
        this.navigate(`frame${this.occurrence()}`);
    };

    startCamera = () => {
        const {btn_camera, occ_camera: {occ_modal: {btn_close}}} = this.get();

        this._handleCameraShow && btn_camera.off('mousedown', this._handleCameraShow);
        this._handleCameraShow = btn_camera.on('mousedown', this.$functions.handleCameraShow);

        this._handleCameraClose && btn_close.off('mousedown', this._handleCameraClose);
        this._handleCameraClose = btn_close.on('mousedown', this.$functions.handleCameraClose);

        this.$helpersIcon.setIcon(this.getFrame(), button.color_icon);
    };

    /**
     *
     */
    initCamera = () => {
        this.startCamera();
    };
}

/**
 *
 * @type {{}}
 */
LayerCamera.propTypes = {
    current_name: PropTypes.string,
    current_page: PropTypes.string
};

/**
 *
 * @type {{}}
 */
LayerCamera.defaultProps = {
    current_name: null,
    current_page: null
};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(LayerCamera, {className: 'LayerCamera'});
